import script from "./SceneMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneMobile.vue?vue&type=script&setup=true&lang=js"

import "./SceneMobile.vue?vue&type=style&index=0&id=2652e1cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2652e1cc"]])

export default __exports__